<style scoped lang="less">
  @import "../styles/color";

  .iconfont {
    position: relative;
    top: 1px;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
  }

  .active {
    color: @primaryColor
  }
</style>
<template>
  <div class="likeButton">
    <div @click="likeOne" v-if="!isLike">
      <i class=" iconfont " :class="[isLike?'active icon-xin2':'icon-xin']"></i>

    </div>
    <div @click="notLikeOne" v-else>
      <i class=" iconfont" :class="[isLike?'active icon-xin2':'icon-xin']"></i>

    </div>
  </div>
</template>
<script>
import bus from '@common/bus'
  import { getLoginUser } from "@common/utils";
  import {
    createProp,
    isLikeInList,
    removeOneLikeInList,
    pushOneLikeInList,
    ajaxLikeCollectOne, ajaxRemoveLikeCollectOne, findIndexLikeInList, jsonParseSafe, getSession, deepClone
  } from "../../common/utils";
  import {go2RegisterForm, isComplateUserProfile} from "../utils";
  import myalert from "../../common/utils/myalert";
  import * as routerUtil from "../../common/utils/routerUtil";

  export default {
    props: {
      info: createProp(Object),
      type: createProp([String, Number])
    },
    computed: {
      likeId() {
        return this.info && this.info.likeCollectVO && this.info.likeCollectVO.likeId
      }
    },
    watch: {
      likeId(newvalue) {
        this.isLike = deepClone(newvalue)
      }
    },
    data() {
      return {
        isLike: false,
        operation: 0,
        likeId_:"",
      }
    },

    mounted() {
      setTimeout(() => {
        this.isLike = this.info && this.info.likeCollectVO && this.info.likeCollectVO.likeId
      }, 1000)
    },
    methods: {
      async likeOne(one) {
        var user = getLoginUser()
        //没有登录跳转登录
        if (user.id == null || user.id == undefined || user.id == '') {
          myalert.confirm("您未登录，请先登录再操作").then(isyes => {
            if (isyes) {
              routerUtil.push("/login")
              bus.$emit('getonbus',true)
              return false
            }
          })

          return false
        }
        if (!isComplateUserProfile()) {
          myalert.fail(`${this.$t('lang.您还没有完善个人信息，请填写完毕后在操作')}`)
          setTimeout(() => {
            go2RegisterForm()
          }, 500)
          return false
        }
        this.isLike = true
        var objectId="";
        if(this.type == '2') {
          objectId = this.info.id
          console.log(objectId);
        } else if (this.type == '0') {
          objectId = this.info.id
          console.log(objectId);
        } else if (this.type == '1') {
          objectId = this.info.id
        } else {
          objectId = this.info.id
        }
        console.log("喜欢的对象",this.info, this.type+"  ",objectId)
        this.likeId_ = await ajaxLikeCollectOne({
          "type": this.type,
          "operation": 0,
          "objectId": objectId,
          passive:this.type + "",
        }).then(res => res.result)
        pushOneLikeInList({
          ...this.info,
          likeId: this.likeId,
          objectId: this.info.id, operation: this.operation,

        })
      },
      notLikeOne() {
        var user = getLoginUser()
        //没有登录跳转登录
        if (user.id == null || user.id == undefined || user.id == '') {
          myalert.confirm("您未登录，请先登录再操作").then(isyes => {
            if (isyes) {
              routerUtil.push("/login")
              bus.$emit('getonbus',true)
              return false
            }
          })

          return false
        }
        this.isLike = false
        removeOneLikeInList(this.info.id, this.operation)
        ajaxRemoveLikeCollectOne(this.likeId_||this.likeId)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/wenxing/components/likeButton.vue